import { StringHelper } from "@octopusdeploy/design-system-octopus-components";
import type { KubernetesResourceManifestSummaryResource } from "@octopusdeploy/octopus-server-client";
import type { KubernetesDetailsFilter } from "~/areas/tasks/components/Task/Kubernetes/KubernetesDetailsLayout";
import { clusterScopedNamespaceFilter, unknownStatusFilter } from "~/areas/tasks/components/Task/Kubernetes/KubernetesDetailsLayout";
export const applyFilterToKubernetesResourceManifestSummary = (krms: KubernetesResourceManifestSummaryResource, filter: KubernetesDetailsFilter) => {
    let showItem = true;
    const checkActiveFilter = (filterValue: string | undefined, filterPredicate: (value: string) => boolean) => {
        //this filter is not active, don't do anything
        if (filterValue === undefined || StringHelper.isNullOrWhiteSpace(filterValue)) {
            return;
        }
        //if any active filter filters this out, run away!
        showItem &&= filterPredicate(filterValue);
    };
    checkActiveFilter(filter.targetName, (targetName) => targetName === krms.MachineName);
    checkActiveFilter(filter.namespace, (namespace) => namespace === (krms.KubernetesObjectNamespace || clusterScopedNamespaceFilter));
    checkActiveFilter(filter.name, (name) => krms.KubernetesObjectName.toLocaleLowerCase().includes(name.toLocaleLowerCase()));
    checkActiveFilter(filter.kind, (kind) => kind === krms.KubernetesResourceKind);
    checkActiveFilter(filter.status, (status) => status === (krms.ResourceStatus || unknownStatusFilter));
    return showItem;
};
